import { makeAutoObservable } from "mobx";

interface Modal {
    open: boolean;
	header: string;
    body: JSX.Element | null;
	showOKButton: boolean;
	size: string;
}
interface Modal2 {
    open2: boolean;
    body2: JSX.Element | null;
}

export default class ModalStore {
    modal: Modal = {
        open: false,
        header: '',
        body: null,
        showOKButton: false,
        size: 'small',
    }

    modal2: Modal2 = {
        open2: false,
        body2: null
    }
    constructor() {
        makeAutoObservable(this);
    }

    openModal = (content: any, header = '', showOKButton = false, customFunction?: Function, size?: any) => {
        this.modal.open = true;
        this.modal.header = header;
        this.modal.body = content;
        this.modal.showOKButton = showOKButton;

        if (customFunction)
            customFunction();

        if(size)
            this.modal.size = size;
    }

    closeModal = () => {
        this.modal.open = false;
        this.modal.body = null;
    }
    openModal2 = (content: any) => {
        this.modal2.open2 = true;
        this.modal2.body2 = content;
    }

    closeModal2 = () => {
        this.modal2.open2 = false;
        this.modal2.body2 = null;
    }
}